// extracted by mini-css-extract-plugin
export default {"user":"User_user__PDpca","title":"User_title__SBKDe"};